import { emitSocketAction } from "../actions/conversation";
import { takeEvery } from "redux-saga/effects";

export default function* handleCloseConversation() {
  yield takeEvery(emitSocketAction, function () {});
}
